import React from 'react';
import { FixedSizeList, ListChildComponentProps, ReactElementType } from 'react-window';
import styled from 'styled-components';

const OuterElementContext = React.createContext({});

const LISTBOX_PADDING = 8;

const OuterElementType = React.forwardRef<HTMLDivElement>((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

const Container = styled.div`
  & ul {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }
  & li {
    list-style: none;
    margin: 0;
  }
`;

function renderRow(props: ListChildComponentProps) {
  const { data, index, style } = props;
  return React.cloneElement(data[index], {
    style: {
      ...style,
    },
  });
}

type ListboxComponentAdapterProps = {
  children?: React.ReactNode;
  itemSize?: number;
  initialScrollOffset?: number;
  height?: number;
  width?: string;
  overscanCount?: number;
  innerElementType?: ReactElementType | undefined;
};

export const ListboxComponentAdapter = React.forwardRef<
  HTMLDivElement,
  ListboxComponentAdapterProps
>((props, ref) => {
  const {
    children,
    height = 300,
    itemSize = 48,
    width = '100%',
    initialScrollOffset = LISTBOX_PADDING,
    overscanCount = 4,
    innerElementType = 'ul',
    ...other
  } = props;
  const itemData = React.Children.toArray(children) as React.ReactPortal[];

  return (
    <Container ref={ref}>
      <OuterElementContext.Provider value={other}>
        <FixedSizeList
          itemSize={itemSize}
          initialScrollOffset={initialScrollOffset}
          itemData={itemData}
          height={height}
          outerElementType={OuterElementType}
          width={width}
          innerElementType={innerElementType}
          overscanCount={overscanCount}
          itemCount={itemData.length}
        >
          {renderRow}
        </FixedSizeList>
      </OuterElementContext.Provider>
    </Container>
  );
});
